import React, { ChangeEvent } from 'react';
import * as mobxReact from 'mobx-react';
import { injectIntl, IntlShape } from 'react-intl';
import { FormField } from '../../../../global/form/form-field/form-field';
import Text from '../../../../global/text/text';
import { ISelectedFilter } from '../../../../../api/events.dao';
import { ReportLayout } from '../../../../../api/reports.dao';
import './save-configuration-body.scss';

interface IProps {
    intl: IntlShape;
    label: string | React.ReactNode;
    nameValue: string;
    handleChangeNameValue: (value: string) => void;
    getNameError: () => JSX.Element | null;
    columns: string[];
    selectedFilters?: ISelectedFilter[];
    layoutType?: ReportLayout;
    children?: React.ReactNode;
}

const SaveConfigurationBody = injectIntl(mobxReact.observer((props: IProps) => {
    const {
        intl,
        label,
        nameValue,
        handleChangeNameValue,
        getNameError,
        columns,
        selectedFilters,
        layoutType,
        children
    } = props;

    const layoutLabel = layoutType === ReportLayout.ROW_PER_ATTENDEE ? intl.formatMessage({
        id: 'oe.reports.oneRowPerAttendee',
        description: 'Label text',
        defaultMessage: '1 Row per Attendee (default)'
    }) : intl.formatMessage({
        id: 'oe.reports.oneRowPerAttendeePerMeeting',
        description: 'Label text',
        defaultMessage: '1 Row per Attendee per Meeting'
    });

    return (
        <div className='save-configuration-form'>
            {children}
            <FormField label={label}>
                <input
                    className='oe-form-field__control'
                    value={nameValue}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => handleChangeNameValue(e.target.value)}
                />
                {getNameError() && <span className='oe-form-field__error'>{getNameError()}</span>}
            </FormField>
            <div className='applied-filters'>
                { layoutType &&
                    <>
                        <div className='applied-filters__title oe-form-field__title'>
                            {intl.formatMessage({
                                id: 'oe.reports.layoutOptions',
                                defaultMessage: 'Layout Options',
                                description: 'Label text'
                            })}
                        </div>
                        <div className='applied-filters__item-group'>
                            <div className='applied-filters__item-title'>{layoutLabel}</div>
                        </div>
                    </>
                }
                <div className='applied-filters__title oe-form-field__title'>
                    {intl.formatMessage({
                        id: 'oe.eventTracker.displayedColumns',
                        defaultMessage: 'Displayed Columns',
                        description: 'Label text'
                    })}
                </div>
                {columns.length ?
                    <div className='applied-filters__item-group'>
                        <div className='applied-filters__item-title'>{columns.join(', ')}</div>
                    </div>
                    :
                    <div className='applied-filters__item-title'>
                        {intl.formatMessage({
                            id: 'oe.eventTracker.noColumns',
                            defaultMessage: 'All Columns are hidden',
                            description: 'Label text'
                        })}
                    </div>
                }
                {selectedFilters?.length ?
                    <div className='applied-filters__title oe-form-field__title'>
                        {intl.formatMessage({
                            id: 'oe.eventTracker.appliedFilters',
                            defaultMessage: 'Applied Filters',
                            description: 'Label text'
                        })}
                    </div>
                    : null
                }
                {selectedFilters?.map(filter => (
                    <div key={filter.filterName} className='applied-filters__item-group'>
                        <div className='applied-filters__item-title'>{filter.filterName}</div>
                        {filter.filterValues.map(filterValue => (
                            <div key={filterValue.id} className='applied-filters__item'>
                                <Text message={filterValue.label} withEllipsis />
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}));

export default SaveConfigurationBody;
